import {observer} from "mobx-react";
import React from "react";
import {FontBody2} from "../../../components/fonts/font-body2/font-body2";
import {FONT_COLOR, FONT_VARIANT} from "../../../components/fonts/font-props";
import useDashboardTranslation from "../../../dashboard-translation/hooks/dashboard-translation-hook";
import RequestProductStore from "../stores/request-product-store";
import Currency from "../../../components/currency/currency";

interface IProps{
	store:RequestProductStore;
}

export const InfoItem: React.FC<{ label:React.ReactNode, value:React.ReactNode }> = ({ label, value }) => (
	<div>
		<span className="item-info-label"><FontBody2 color={FONT_COLOR.NEUTRAL3}>{label}:</FontBody2></span>
		<FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{value}</FontBody2>
	</div>
);

const ItemPreview:React.FC<IProps> = observer(({store})=>{
    
    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-create-rma';
	return (
		<div className='add-item-drawer'>
			<div className='add-item-grid'>
				<div className='add-item-image-flex'>
					<img alt='product' src={store.orderProductStore.imageUrl} className='product-image'/>
					<div>
						<div><FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{store.orderProductStore.name}</FontBody2></div>
						<FontBody2 color={FONT_COLOR.NEUTRAL3}>{store.orderProductStore.variantTitle}</FontBody2>
					</div>
				</div>
				
				<InfoItem label={getTranslation('CATALOG_PRICE', pageScope)} value={
					<FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
						<Currency currencyCode={store.paymentCurrencyCode!} amount={store.orderProductStore.catalogPrice}/> 
						{ !!store.compareAtPrice &&
							<>
								{' ('}
								<FontBody2 variant={FONT_VARIANT.LINE_TROUGH}>
									<Currency currencyCode={store.paymentCurrencyCode} amount={store.compareAtPrice}/>
								</FontBody2>
								{')'}
							</>
                        } / item
					</FontBody2>
				} />

				<InfoItem label={getTranslation('QUANTITY', pageScope)} value={store.getAvailableQuantity()} />

				<InfoItem label={getTranslation('DISCOUNTS', pageScope)} value={
					<FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
						<Currency currencyCode={store.paymentCurrencyCode!} amount={store.orderProductStore.discountAmount}/>
					</FontBody2>
				} />
				
				<InfoItem label={getTranslation('PAID_AMOUNT', pageScope)} value={
					<FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
						<Currency currencyCode={store.paymentCurrencyCode!} amount={store.totalPaidAmount}/>
					</FontBody2>
				} />
			</div>
		</div>
	)
});

export default ItemPreview;